// Ogółem są dostępne te 4 typy toast-ów, ale defaultowym jest notification
// Jeśli omyłkowo zostanie wpisany jakiś inny typ, aniżeli ten z poniższych, to zostanie wyświetlony ciemny tost z ikonką powiadomienia
export default {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
  notification: 'notification'
};